import React from "react";
import { Routes, Route } from "react-router-dom";
import ListProperties from "../Components/Properties/listProperties";
import ViewProperties from "../Components/Properties/viewProperties";
import EditProperties from "../Components/Properties/editProperties";

const PropertiesRoutes = () => {
  return (
    <Routes>
      <Route
        path="/manage_properties"
        element={<ListProperties></ListProperties>}
      ></Route>
      <Route
        path="/manage_properties/view/:id"
        element={<ViewProperties></ViewProperties>}
      ></Route>
      <Route
        path="/manage_properties/edit/:id"
        element={<EditProperties></EditProperties>}
      ></Route>
    </Routes>
  );
};

export default PropertiesRoutes;
